import type { JSX } from "preact"

import { blocosDoTexto, type Bloco, type Trecho } from "../lib/marcacao"

/**
 * O texto de uma mensagem, com as marcações do WhatsApp.
 *
 * Monta ELEMENTOS a partir da árvore do analisador. Não existe `innerHTML` aqui,
 * e é de propósito: a mensagem vem de fora — do visitante, do atendente — e um
 * `<img onerror=...>` tem de continuar sendo texto na tela.
 */

function desenharTrechos(trechos: Trecho[], chave: string): JSX.Element[] {
  return trechos.map((trecho, i) => {
    const k = `${chave}-${i}`
    if (trecho.tipo === "texto") return <span key={k}>{trecho.texto}</span>
    const filhos = desenharTrechos(trecho.filhos, k)
    if (trecho.tipo === "negrito") return <strong key={k}>{filhos}</strong>
    if (trecho.tipo === "italico") return <em key={k}>{filhos}</em>
    if (trecho.tipo === "riscado") return <del key={k}>{filhos}</del>
    return (
      <code class="mono" key={k}>
        {filhos}
      </code>
    )
  })
}

function desenharBloco(bloco: Bloco, chave: string): JSX.Element {
  if (bloco.tipo === "lista") {
    const itens = bloco.itens.map((item, i) => (
      <li key={`${chave}-i${i}`}>{desenharTrechos(item, `${chave}-i${i}`)}</li>
    ))
    return bloco.ordenada ? (
      <ol class="lista" key={chave}>
        {itens}
      </ol>
    ) : (
      <ul class="lista" key={chave}>
        {itens}
      </ul>
    )
  }

  if (bloco.tipo === "citacao") {
    return (
      <blockquote class="citacao" key={chave}>
        {desenharTrechos(bloco.conteudo, chave)}
      </blockquote>
    )
  }

  // Parágrafo vazio existe para a linha em branco continuar valendo um espaço.
  return (
    <span class="linha" key={chave}>
      {desenharTrechos(bloco.conteudo, chave)}
    </span>
  )
}

export function Texto({ texto }: { texto: string }) {
  if (!texto) return null
  return <>{blocosDoTexto(texto).map((bloco, i) => desenharBloco(bloco, `b${i}`))}</>
}
